import { Card, Col, Flex, Image, Row, Tag } from "antd";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { generateRandomString } from "utils/helper";
import icon from "../../../assets/images/document-text.svg";
import { getRequestLoanList } from "../services/webAppApi";
import { setIsLoading, setRequestLoanList } from "../slices/webappSlice";

const useHistory = () => {
    const { t, i18n } = useTranslation();
    const p9 = t("becash.label.transaction_history")
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { isLoading, requestLoanList } = useSelector((state) => state.webapp);
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    console.log("requestLoanList", requestLoanList);

    function tagContractStatus(transferStatus) {
        console.log("transfertag", transferStatus);

        switch (transferStatus?.code) {
            case "WAITING":
                return (
                    <Tag color="geekblue">{i18n.language === "en" ? transferStatus?.nameEN : transferStatus?.name}</Tag>
                )
            case "TRANSFERED":
                return (
                    <Tag color="success">{i18n.language === "en" ? transferStatus?.nameEN : transferStatus?.name}</Tag>
                )
            case "EXPORTED":
                return (
                    <Tag color="default">{i18n.language === "en" ? transferStatus?.nameEN : transferStatus?.name}</Tag>
                )
            default: return ("")
        }
    }

    const serviceRequestLoanList = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getRequestLoanList({
                ...params,
                requestId: generateRandomString(),
                page: 0, size: 100
            });
            // console.log("response", response);
            console.log("data", response.data);
            dispatch(setRequestLoanList(response?.data?.page?.content))
        } catch (error) {
            console.log("error", error);
            // alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    // const serviceLoanDetails = async (params) => {
    //     try {
    //         dispatch(setIsLoading(true));
    //         const response = await getRequestLoanList({
    //             ...params,
    //             requestId: generateRandomString(),
    //             employeeNo: "202020"
    //         });
    //         console.log("response", response);
    //         console.log("data", response.data);
    //         dispatch(setRequestLoanList(response?.data?.content))
    //     } catch (error) {
    //         alert({ type: "error", resultObject: error });
    //     } finally {
    //         dispatch(setIsLoading(false));
    //     }
    // }

    useEffect(() => {
        serviceRequestLoanList()
    }, [])

    function cardHis() {
        return <Flex vertical style={{
            height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            rowGap: "2vh"
        }}>
            {requestLoanList?.map(item => {
                console.log("transferStatus log:", item?.transferStatus);

                return (
                    <Card
                        key={item?.id}
                        onClick={() => {
                            console.log("click id", item.id);
                            // (Modal.info({ content: item.id }))
                            navigate("/webapp/complete", { state: { txnId: item.id } });

                        }}
                        style={{
                            borderRadius: "1rem",
                            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                        }}>

                        <Flex vertical style={{ rowGap: "1.5vh" }}>
                            <Row>
                                <Col span={12} style={{ display: "flex", alignItems: "center", gap: "1vw" }}>
                                    <Image
                                        preview={false}
                                        width={isPortrait ? "2.5vh" : "2.5vw"}
                                        src={icon}
                                    />
                                    <span style={{ fontSize: isPortrait ? "2vh" : "2vw" }}>{item.requestCode}</span>
                                </Col>
                                <Col span={12} style={{ display: 'flex', alignItems: 'center', placeContent: "flex-end" }}>
                                    <span style={{ fontSize: isPortrait ? "1.5vh" : "1.5vw" }}>{dayjs(item.requestDate).format("DD MMM BBBB")}</span>
                                </Col>
                            </Row>
                            <Flex vertical style={{ color: "#909090", rowGap: "0.5vh" }}>
                                <Row>
                                    <Col span={12}><span>วงเงินที่ได้รับอนุมัติ</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(item.creditUsage) + " บาท"}</span></Col>
                                </Row>
                                <Row>
                                    <Col span={12}><span>ค่าธรรมเนียม</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(item.feeAmount) + " บาท"}</span></Col>
                                </Row>
                                <Row>
                                    <Col span={12}><span>ดอกเบี้ย</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>-</span></Col>
                                </Row>
                                <Row>
                                    <Col span={12}><span>ยอดที่ต้องชำระทั้งหมด</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(item.balancePaid) + " บาท"}</span></Col>
                                </Row>
                            </Flex>
                            <Row style={{ height: isPortrait ? "3vh" : "3vw", alignContent: "flex-end" }}>
                                {tagContractStatus(item?.transferStatus)}
                            </Row>

                        </Flex>
                    </Card >
                )
            })}
        </Flex>

    }

    return {
        p9,
        cardHis,
    }
}
export default useHistory;